import React from "react";

import { CHART } from "@/pages/admin/compliance/analytics/components/primitives";
import { fmt, fmtCompact } from "./format";

/**
 * One headline figure.
 *
 * The number is compact and the exact value sits in the `title`, because a
 * 1,550,000 next to a 412 makes the pair unreadable while "1.55M" and "412"
 * compare at a glance. The accent is a left border only — the tile keeps the
 * theme's own surface, so the same markup reads in light and in dark without a
 * second palette.
 *
 * `hint` is for the caveat the number needs to be honest: what a cache hit did
 * not cost, what a failed call did not produce.
 *
 * `display` overrides the formatted value for the tiles whose headline is not a
 * count — a percentage, a ratio. `exact` overrides the hover text with them.
 */
const UsageStat = ({ label, value, hint, accent = CHART.indigo, icon: Icon, exact, display }) => (
  <div
    // A solid surface, not a tinted one. At 50% the tile all but vanished on
    // the light theme, where the page and the card behind it are both near
    // white.
    className="flex flex-col justify-between gap-2 rounded-xl border border-border-primary bg-background-primary p-4"
    style={{ borderLeftWidth: 3, borderLeftColor: accent }}
  >
    <div className="flex items-center gap-1.5">
      {Icon ? <Icon className="h-3.5 w-3.5 flex-shrink-0 text-text-secondary" /> : null}
      <span className="text-[11px] font-medium uppercase tracking-wide text-text-secondary">{label}</span>
    </div>
    <div>
      <p className="text-2xl font-semibold leading-none tracking-tight text-text-primary tabular-nums" title={exact ?? fmt(value)}>
        {display ?? fmtCompact(value)}
      </p>
      {hint ? <p className="mt-1.5 text-[11px] leading-tight text-text-secondary">{hint}</p> : null}
    </div>
  </div>
);

export default UsageStat;
